import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { Card } from '@components/molecules/Card/Card';
import { Footer as FooterElement } from '@components/molecules/Footer/Footer';

import { maxWidth } from '@utils/helpers';

import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { CONTAINER_SIDE_PADDINGS } from '@shared/constants';

export const WelcomePageWrapper = styled.div(
    ({ theme: { palette } }) => css`
        display: grid;
        grid-template-rows: 70px 1fr 70px;
        min-height: 100vh;
        padding: 0 ${CONTAINER_SIDE_PADDINGS.default}px;
        position: relative;
        width: 100%;

        ${maxWidth('md')} {
            padding: 0 ${CONTAINER_SIDE_PADDINGS.md}px;
        }

        ${maxWidth('sm')} {
            padding: 0 ${CONTAINER_SIDE_PADDINGS.xs}px;
        }

        &::before {
            background-color: ${palette.tertiary.background};
            content: '';
            height: 100%;
            position: fixed;
            right: 0;
            top: 0;
            width: 40%;

            ${maxWidth('md')} {
                display: none;
            }
        }
    `,
);

export const HeaderLogo = styled.img`
    width: 136px;

    ${maxWidth('md')} {
        width: 118px;
    }
`;

export const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ContentWrapper = styled.div`
    align-items: center;
    display: flex;
    gap: 86px;
    justify-content: space-between;
    justify-self: center;
    max-width: 1140px;
    padding: 24px 0;
    position: relative;
    width: 100%;
    z-index: 1;

    ${maxWidth('lg')} {
        gap: 44px;
    }

    ${maxWidth('md')} {
        flex-direction: column;
        padding: 64px 0 48px;
    }
`;

export const ContentCard = styled(Card)`
    flex-shrink: 0;
    max-width: 556px;
    min-height: unset;
    width: 100%;

    ${maxWidth('md')} {
        max-width: unset;
        padding: 48px 48px 56px;
    }

    ${maxWidth('sm')} {
        padding: 0;
    }
`;

export const CartTitle = styled(Card.TitleTertiary)`
    margin-bottom: 24px;
`;

export const MobileTitle = styled(Card.Title)(
    ({ theme: { fontSize } }) => css`
        ${maxWidth('md')} {
            text-align: center;
        }

        ${maxWidth('xxs')} {
            font-size: ${fontSize[26]}px;
            line-height: 1.3;
            margin-bottom: 16px;
        }
    `,
);

export const MobileDescription = styled(Typography.TextBody_16_28)`
    margin: 0 auto 40px;
    max-width: 292px;
    text-align: center;
`;

export const Footer = styled(FooterElement)`
    align-items: flex-end;
`;

export const WelcomeHintBanner = styled(LoginBanner)`
    margin-top: 32px;
    padding: 20px 32px 24px;

    ${maxWidth('sm')} {
        padding: 20px 20px 16px;
    }
`;
